import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Library, FileCheck, Calculator, ArrowRight } from "lucide-react";
import { toolsGuides } from "../../mock";
import Reveal from "../Reveal";

const iconMap = { BookOpen, Library, FileCheck, Calculator };

export default function ToolsSection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Free Resources</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
            Tools &amp; Guides
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Everything you need to navigate the lending process — written in plain English by
            experienced lending professionals.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-7 sm:grid-cols-2 lg:grid-cols-4">
          {toolsGuides.map((t, i) => {
            const Icon = iconMap[t.icon] || Calculator;
            return (
              <Reveal key={t.slug} delay={(i % 4) * 90}>
                <Link
                  to={`/tools?tab=${t.slug}`}
                  className="group block h-full rounded-2xl bg-white p-7 ring-1 ring-slate-100 shadow-sm hover:shadow-2xl hover:-translate-y-1.5 transition-all duration-300"
                >
                  <div className="h-14 w-14 rounded-xl bg-[#0b1f3a] flex items-center justify-center group-hover:bg-[#c6a15b] transition-colors">
                    <Icon className="h-7 w-7 text-[#c6a15b] group-hover:text-[#0b1f3a] transition-colors" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-[#0b1f3a] mt-6 group-hover:text-[#b08e46] transition-colors">
                    {t.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{t.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#c6a15b]">
                    {t.cta}
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/tools"
            className="inline-flex items-center gap-2 rounded-md bg-[#0b1f3a] px-7 py-3.5 font-bold text-white hover:bg-[#13294b] transition-colors"
          >
            Explore All Tools <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
